import React, { useRef } from "react";

// Text tab strip with roving tabindex. `onSelect(value)` is called on click
// and on arrow/Home/End keys; selection is owned by the caller (usually URL).
export default function TabStrip({ items, value, onSelect, label, panelId, idPrefix = "ro-tab" }) {
  const refs = useRef([]);
  const go = (i, focus) => {
    onSelect(items[i].value);
    if (focus && refs.current[i]) refs.current[i].focus();
  };
  const onKeyDown = (e, i) => {
    let n = null;
    if (e.key === "ArrowRight") n = (i + 1) % items.length;
    else if (e.key === "ArrowLeft") n = (i - 1 + items.length) % items.length;
    else if (e.key === "Home") n = 0;
    else if (e.key === "End") n = items.length - 1;
    if (n === null) return;
    e.preventDefault();
    go(n, true);
  };
  return (
    <div className="ro-tabstrip" role="tablist" aria-label={label}>
      {items.map((it, i) => {
        const active = it.value === value;
        return (
          <button
            key={it.value}
            ref={(el) => (refs.current[i] = el)}
            type="button"
            role="tab"
            id={`${idPrefix}-${it.value}`}
            aria-selected={active}
            aria-controls={panelId}
            tabIndex={active ? 0 : -1}
            className={`ro-tabstrip__tab ${active ? "is-active" : ""}`}
            onClick={() => go(i, false)}
            onKeyDown={(e) => onKeyDown(e, i)}
          >
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
